export default __webpack_public_path__ + "static/media/eu.2a0e9b9f.png";